/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_AutoInputs */

const en_model_auto = /** @type {(inputs: Model_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const id_model_auto = /** @type {(inputs: Model_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Model_AutoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_auto = /** @type {((inputs?: Model_AutoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_AutoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_auto(inputs)
	return en_model_auto(inputs)
});